module.exports = __webpack_public_path__ + "static/media/green_overlay_left.6aa20340.svg";